import React from "react";
import Iframe from "react-iframe";
import { useRouter } from "next/router";

import {
  Container,
  VideoCardContainer,
  SummaryContainer,
  TitleText,
  SummaryText,
  ActionButton,
} from "./styled";

const VideoContentSection = () => {
  const router = useRouter();

  return (
    <Container>
      <VideoCardContainer>
        <Iframe
          title="Classy Closets' Franchise Info"
          ariaLabel="Franchise Info Video"
          url="https://www.youtube.com/embed/PBIm-PY1aT4?wmode=opaque&rel=0"
          width="100%"
          height="100%"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
          role="none"
        />
      </VideoCardContainer>
      <SummaryContainer>
        <TitleText>START YOUR CLASSY CLOSETS FRANCHISE</TitleText>
        <SummaryText>
          Classy Closets is the premier provider of custom home storage
          solutions. If you share our vision of distinctive quality and customer
          service, and take pride in the products and services you offer, then
          join our team as a franchise owner.
        </SummaryText>
        <ActionButton
          ptype="default"
          pname="REQUEST INFO"
          onClick={() =>
            router.push("/franchise-opportunities#franchise_brochure")
          }
        />
      </SummaryContainer>
    </Container>
  );
};

export default VideoContentSection;
